import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './components/footer.component';
import { CompanyTextModule } from '../company-text/company-text.module';

@NgModule({
  declarations: [FooterComponent],
  imports: [CommonModule, CompanyTextModule],
  exports: [FooterComponent],
})
export class FooterModule {}
